import { useState } from 'react';

import { useGetOrderDetailById } from 'shared/hooks';

import type { OrderId } from 'shared/domain';

export function useTotalsDetailModule({ orderId }: Props) {
  const [isOpen, setIsOpen] = useState(false);

  const { data: order } = useGetOrderDetailById(orderId);

  const isRender = !isNaN(order.id);
  const hasDetails = order.totals.detail.length > 1;
  const isFSDeliveryMethod = order.deliveryMethod === 'delivery';

  const handleToggle = () => {
    if (hasDetails) setIsOpen(!isOpen);
  };

  return {
    isRender,
    isOpen,
    isFSDeliveryMethod,
    hasDetails,
    totals: order.totals,
    handleToggle,
  };
}

interface Props {
  orderId: OrderId;
}
